import { render, staticRenderFns } from "./MBreadcrum.vue?vue&type=template&id=6eabbcc6&"
import script from "./MBreadcrum.vue?vue&type=script&lang=js&"
export * from "./MBreadcrum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VHover,VIcon,VSlideYReverseTransition})
